import {
  IBenefitSummary,
  IPlanBenefitSummaryList,
  LimitComparison,
} from '@nibtravel/shared/util/models';
import { flatten, groupBy } from 'lodash-es';

export class PlanBenefitsHelper {
  static toBenefitsSummary(
    data: Record<number, IPlanBenefitSummaryList>
  ): IBenefitSummary[] {
    const allBenefits = flatten(
      Object.entries(data).map(([planId, summary]) => {
        return summary.benefits.map((benefit) => ({
          planId: Number.parseInt(planId),
          benefit,
        }));
      })
    );
    const planIds = Object.keys(data).map((planId) => Number.parseInt(planId));
    const benefits = groupBy(allBenefits, (item) => item.benefit.code);

    return Object.entries(benefits).map(([, items]) => {
      return this.transformBenefits(items, planIds);
    });
  }

  private static transformBenefits(
    items: Array<{ planId: number; benefit: IBenefitSummary }>,
    planIds: number[]
  ): IBenefitSummary {
    const benefit = items[0].benefit; // Can just get first benefit in list

    const newBenefit = {
      ...benefit,
      limitComparison: this.getComparison(planIds, items),
    };

    const allChildBenefits = flatten(
      items.map((item) => {
        return (
          item.benefit.childBenefits?.map((benefit) => ({
            planId: item.planId,
            benefit,
          })) || []
        );
      })
    );

    if (allChildBenefits.length > 0) {
      const groupedChildBenefits = groupBy(
        allChildBenefits,
        (item) => item.benefit.code
      );
      const childBenefits = Object.values(groupedChildBenefits).map((items) => {
        return {
          ...items[0].benefit, // Can just get first benefit in list
          limitComparison: this.getComparison(planIds, items),
        };
      });

      return {
        ...newBenefit,
        childBenefits,
      };
    }

    return newBenefit;
  }

  private static getComparison(
    planIds: number[],
    data: Array<{ planId: number; benefit: IBenefitSummary }>
  ): LimitComparison {
    return planIds.reduce((acc, planId) => {
      const benefit = data.find((item) => item.planId === planId)?.benefit;
      acc[planId] =
        benefit?.perPolicyHolderLimit ??
        benefit?.limitDescription ??
        'Not insured';

      return acc;
    }, {} as LimitComparison);
  }
}
